import { useEffect, useState } from 'react';

/**
 * Hook that returns `true` once the component has hydrated on the client.
 * Useful for deferring renders of components that produce non-deterministic
 * output (e.g. UUIDs in aria attributes or tracking URLs) which would
 * otherwise cause a hydration mismatch between server and client.
 */
export const useIsHydrated = (): boolean => {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  return isHydrated;
};
